<template>
  <div class="mini-program-link-container animated fadeInRight">
    <el-card>
      <div slot="header" class="flex justify-between">
        <span>小程序链接管理</span>
        <el-button type="primary" size="small" @click="_openAddDialog">
          <i class="el-icon-plus"></i>新增
        </el-button>
      </div>
      <el-row :gutter="20">
        <el-col :span="4">
          <el-input v-model="conditions.name" placeholder="名称搜索" clearable />
        </el-col>
        <el-col :span="4">
          <el-button type="primary" @click="_queryMethod()">搜索</el-button>
        </el-col>
      </el-row>
    </el-card>

    <el-card style="margin-top:20px">
      <el-table :data="links" border style="width:100%" v-loading="loading">
        <el-table-column label="图标" align="center" width="80">
          <template slot-scope="scope">
            <el-image v-if="scope.row.iconUrl" :src="scope.row.iconUrl" style="width:40px;height:40px" fit="cover" :preview-src-list="[scope.row.iconUrl]" />
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="名称" align="center" />
        <el-table-column prop="appId" label="AppID" align="center" />
        <el-table-column prop="path" label="页面路径" align="center" />
        <el-table-column prop="sort" label="排序" align="center" width="80" />
        <el-table-column label="操作" align="center" width="160">
          <template slot-scope="scope">
            <el-button size="mini" @click="_openEditDialog(scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="_deleteRow(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination style="margin-top:15px" @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="page.current" :page-sizes="[10, 20, 30, 50]" :page-size="page.size"
        layout="total, sizes, prev, pager, next, jumper" :total="page.total" />
    </el-card>

    <!-- 新增/编辑弹窗 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="500px" @close="_resetForm">
      <el-form :model="form" :rules="formRules" ref="formRef" label-width="100px" size="small">
        <el-form-item label="名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入名称" />
        </el-form-item>
        <el-form-item label="图标" prop="iconUrl">
          <el-upload
            action=""
            :show-file-list="false"
            :before-upload="beforeUpload"
            :http-request="handleUpload"
          >
            <img v-if="form.iconUrl" :src="form.iconUrl" style="width:60px;height:60px;object-fit:cover;border-radius:4px;" />
            <div v-else class="upload-btn">
              <i class="el-icon-plus"></i>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="AppID" prop="appId">
          <el-input v-model="form.appId" placeholder="请输入AppID" />
        </el-form-item>
        <el-form-item label="页面路径" prop="path">
          <el-input v-model="form.path" placeholder="请输入页面路径（选填）" />
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input-number v-model="form.sort" :min="0" :max="9999" style="width:100%" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="_submitForm">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  name: 'MiniProgramLinkList',
  data() {
    return {
      loading: false,
      links: [],
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      conditions: {
        name: '',
        communityId: ''
      },
      dialogVisible: false,
      isEdit: false,
      form: {
        linkId: '',
        name: '',
        iconUrl: '',
        appId: '',
        path: '',
        sort: 0
      },
      formRules: {
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        iconUrl: [{ required: true, message: '请上传图标', trigger: 'change' }],
        appId: [{ required: true, message: '请输入AppID', trigger: 'blur' }],
        sort: [{ required: true, message: '请输入排序', trigger: 'blur' }]
      }
    }
  },
  computed: {
    dialogTitle() {
      return this.isEdit ? '编辑小程序链接' : '新增小程序链接'
    }
  },
  created() {
    this.conditions.communityId = ''
    this._listLinks()
  },
  methods: {
    async _listLinks() {
      try {
        this.loading = true
        const params = {
          ...this.conditions,
          page: this.page.current,
          row: this.page.size
        }
        const response = await request({
          url: '/miniProgramLink.listMiniProgramLinks',
          method: 'get',
          params
        })
        const res = response.data
        this.links = res.data || res.links || []
        this.page.total = res.total || 0
      } catch (error) {
        this.$message.error('获取列表失败')
      } finally {
        this.loading = false
      }
    },
    _queryMethod() {
      this.page.current = 1
      this._listLinks()
    },
    _openAddDialog() {
      this.isEdit = false
      this._resetForm()
      this.dialogVisible = true
    },
    _openEditDialog(row) {
      this.isEdit = true
      this.form = {
        linkId: row.linkId || '',
        name: row.name || '',
        iconUrl: row.iconUrl || '',
        appId: row.appId || '',
        path: row.path || '',
        sort: row.sort || 0
      }
      this.dialogVisible = true
    },
    _resetForm() {
      this.form = {
        linkId: '',
        name: '',
        iconUrl: '',
        appId: '',
        path: '',
        sort: 0
      }
      if (this.$refs.formRef) {
        this.$refs.formRef.clearValidate()
      }
    },
    _submitForm() {
      this.$refs.formRef.validate(async (valid) => {
        if (!valid) return
        try {
          const params = {
            ...this.form,
            communityId: this.conditions.communityId
          }
          if (this.isEdit) {
            await request({
              url: '/miniProgramLink.updateMiniProgramLink',
              method: 'post',
              data: params
            })
          } else {
            await request({
              url: '/miniProgramLink.saveMiniProgramLink',
              method: 'post',
              data: params
            })
          }
          this.$message.success('操作成功')
          this.dialogVisible = false
          this._listLinks()
        } catch (error) {
          this.$message.error('操作失败')
        }
      })
    },
    _deleteRow(row) {
      this.$confirm('确定删除该小程序链接吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          await request({
            url: '/miniProgramLink.deleteMiniProgramLink',
            method: 'post',
            data: { linkId: row.linkId }
          })
          this.$message.success('删除成功')
          this._listLinks()
        } catch (error) {
          this.$message.error('删除失败')
        }
      }).catch(() => {})
    },
    beforeUpload(file) {
      const isImage = file.type.includes('image/')
      const isLt10M = file.size / 1024 / 1024 < 10
      if (!isImage) {
        this.$message.error('只能上传图片文件')
      }
      if (!isLt10M) {
        this.$message.error('图片大小不能超过10MB')
      }
      return isImage && isLt10M
    },
    async handleUpload({ file }) {
      try {
        const formData = new FormData()
        formData.append('uploadFile', file)
        const response = await request({
          url: '/callComponent/upload/uploadFile/uploadImage',
          method: 'post',
          data: formData,
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        const res = response.data
        if (res.code === 0) {
          this.form.iconUrl = res.url || res
        } else {
          this.$message.error(res.msg || '上传失败')
        }
      } catch (error) {
        this.$message.error('上传失败')
      }
    },
    handleSizeChange(val) {
      this.page.size = val
      this._listLinks()
    },
    handleCurrentChange(val) {
      this.page.current = val
      this._listLinks()
    }
  }
}
</script>

<style lang="scss" scoped>
.mini-program-link-container {
  padding: 20px;

  .upload-btn {
    width: 60px;
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    background-color: #fbfdff;

    &:hover {
      border-color: #409eff;
    }

    i {
      font-size: 20px;
      color: #8c939d;
    }
  }
}
</style>
